import { FC } from 'react';

import { CURRENCY_SYMBOL } from '@/shared/constants';

interface Props {
  price: number | undefined;
  short?: boolean;
  testId?: string;
}

const PriceText: FC<Props> = ({ price, short, testId }) => {
  if (!price) {
    return `0 ${CURRENCY_SYMBOL}`;
  }

  if (short) {
    let formattedValue = price.toString();
    if (price >= 1000000) {
      formattedValue = `${Math.round(price / 1000000)}m`;
    } else if (price >= 1000) {
      formattedValue = `${Math.round(price / 1000)}k`;
    }

    return `${formattedValue} ${CURRENCY_SYMBOL}`;
  }

  const [integer, decimals] = price.toFixed(2).split('.');

  return (
    <span data-testid={testId} data-price={price.toFixed(2)}>
      <span>
        {parseInt(integer).toLocaleString('ro-RO', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })}
      </span>
      {!!decimals && decimals !== '00' && (
        <sup
          style={{
            fontSize: '0.85em',
            marginTop: 0,
            paddingTop: 0,
          }}
        >
          {decimals}
        </sup>
      )}
      <span> {CURRENCY_SYMBOL}</span>
    </span>
  );
};

export default PriceText;
